import { Component, OnInit, Inject, Output, EventEmitter } from '@angular/core';  ///----------- for searching pop up -----------
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ComplainsModel } from 'src/app/models/ComplainsModel';
import { ComplainsService } from 'src/app/services/ComplainsService';

@Component({
  selector: 'app-complains-search',
  templateUrl: './complains-search.component.html',
  styleUrls: ['./complains-search.component.css']
})
export class ComplainsSearchComponent implements OnInit {
  thcode = 0 ;
  thname = '' ;
  compcode = '' ;
  userid = '' ;
  modifieddate = '2024-01-01' ;
  ComplaintList : ComplainsModel[]=[];
  @Output() submitClicked = new EventEmitter<any>();                    ///----------- for searching pop up -----------

  constructor(public dialogRef: MatDialogRef<ComplainsSearchComponent>,
              public ComplainsService : ComplainsService,
              @Inject(MAT_DIALOG_DATA)                                  ///----------- for searching pop up -----------
              public complainsSelected : ComplainsModel,) { }

  ngOnInit(): void {
    this.retriveComplainsLookupTop();
  }
  retriveComplainsLookupTop() {
    this.ComplaintList = [];
    this.ComplainsService.getComplainsLookupTop().subscribe((data: ComplainsModel[]) => {
      for (let i = 0; i < data.length; i++) {
        this.ComplaintList[i] = data[i];
      }
    })
  }
  RetriveComplainsLookup(){
    this.ComplaintList = [];
    this.ComplainsService.getComplainsLookup(this.thname).subscribe((data: ComplainsModel[]) => {
      for (let i = 0; i < data.length; i++) {
        this.ComplaintList[i] = data[i];
      }
    })
  }
  Selectcomplains(Do : ComplainsModel){
    this.complainsSelected.thcode = Do.thcode;
    this.complainsSelected.thname = Do.thname;
    this.submitClicked.emit(this.complainsSelected);
    this.dialogRef.close();
  }
}
